import { render, staticRenderFns } from "./ActiveSuspension.vue?vue&type=template&id=5c9f7e1c&scoped=true&"
import script from "./ActiveSuspension.vue?vue&type=script&lang=js&"
export * from "./ActiveSuspension.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSuspension.vue?vue&type=style&index=0&id=5c9f7e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9f7e1c",
  null
  
)

export default component.exports